import React from 'react';
import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];
// Dev/test helper: ?nomotion renders final states without entrance animation.
const TEST = typeof window !== 'undefined' && window.location.search.includes('nomotion');

// Restrained fade-up reveal on scroll.
export const Reveal = ({ children, delay = 0, y = 40, className = '', as = 'div' }) => {
  const MotionTag = motion[as] || motion.div;
  if (TEST) { const Tag = as; return <Tag className={className}>{children}</Tag>; }
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal. `lines` is an array of strings.
export const LineReveal = ({ lines, className = '', lineClassName = '', delay = 0, stagger = 0.09 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden pt-[0.12em] pb-[0.16em] -my-[0.1em]">
        <motion.div
          className={lineClassName}
          initial={{ y: '120%' }}
          animate={{ y: '0%' }}
          transition={{ duration: 1.2, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

// Masked reveal triggered on scroll into view.
export const LineRevealOnView = ({ lines, className = '', lineClassName = '', stagger = 0.09 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden pt-[0.12em] pb-[0.16em] -my-[0.1em]">
        <motion.div
          className={lineClassName}
          initial={TEST ? false : { y: '120%' }}
          whileInView={{ y: '0%' }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 1.1, ease: EASE, delay: i * stagger }}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);
